import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatFacade } from 'src/shared/stores/chat/chat-facade.store';
import { TrialsAuthenticatedStoreProviders } from '../../providers/trials-authenticated-stores';

/**
 * Trials authenticated container component.
 * Wraps authenticated trials routes and provides chat (no PolicyStore or other app-only stores).
 * When this component is destroyed, chat services are destroyed.
 */
@Component({
  selector: 'app-trials-authenticated-container',
  imports: [RouterOutlet],
  providers: [...TrialsAuthenticatedStoreProviders],
  templateUrl: './trials-authenticated-container.component.html',
  styleUrl: './trials-authenticated-container.component.scss',
})
export class TrialsAuthenticatedContainerComponent {
  chat = inject(ChatFacade);
}
